import React, { useMemo } from 'react';
import { useQueryWithStore } from 'react-admin';
import MenuItem from '@material-ui/core/MenuItem';
import makeStyles from '@material-ui/core/styles/makeStyles';

import SelectBase from 'components/form/SelectBase';

const useStyles = makeStyles(() => ({
  providerIcon: {
    maxWidth: 24,
    maxHeight: 24,
    marginRight: 4,
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
  },
  select: {
    '& .MuiSelect-select': {
      backgroundColor: 'transparent',
      padding: '8px 0 13px',
      display: 'flex',
      alignItems: 'center',
    },
  },
  root: {},
}));

const ProvidersSelect = ({ name, label, ...rest }) => {
  const classes = useStyles();

  const { data: providers } = useQueryWithStore({
    type: 'GET_LIST',
    resource: 'deliveryProviders',
    payload: { pagination: { perPage: 25 } },
  });

  const options = useMemo(
    () =>
      providers?.map((provider) => ({
        value: provider.code,
        label: provider.shortName,
        icon: provider.logoUrl,
      })),
    [providers]
  );

  return (
    <SelectBase
      label={label}
      name={name}
      {...rest}
      inputProps={{ readOnly: !!!options?.length }}
      classes={classes}>
      {options?.map((option) => (
        <MenuItem
          className={classes.menuItem}
          key={option.value.id || option.value}
          value={option.value}>
          <img src={option.icon} className={classes.providerIcon} alt="provider" />
          {option.label}
        </MenuItem>
      ))}
    </SelectBase>
  );
};

export default ProvidersSelect;
